const TipoNaviera = [{
    value: "CMA",
    label: "CMA CGM"
  }, {
    value: "HAP",
    label: "Hapag LLoyd"
  },
  {
    value: "ONE",
    label: "One Networks"
  },
  {
    value: "AGN",
    label: "Agnamex"
  },
  {
    value: "ALT",
    label: "Zim"
  },
  {
    value: "GRM",
    label: "Grimaldi"
  },
  {
    value: "ETC",
    label: "Las demás"
  },

];
  
  export default TipoNaviera